import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCounts from '../reducers/counts.reducer';

export const selectCountsState = createFeatureSelector<fromCounts.State>(
  fromCounts.countsFeatureKey
);

export const selectCountsInventoryState = createSelector(
  selectCountsState,
  (state) => state.inventory
);

export const selectCurrentInventoryItemState = createSelector(
  selectCountsState,
  (state) => state.currentInventoryItem
);

export const selectFinalizedCountState = createSelector(
  selectCountsState,
  (state) => state.finalizedInventory
);

export const selectCountsCurrentIdState = createSelector(
  selectCountsState,
  (state) => state.currentId
);

export const selectCountsCurrentInventoryState = createSelector(
  selectCountsState,
  (state) => state.currentInventory
);

export const selectCountsMostRecentState = createSelector(
  selectCountsState,
  (state) => state.mostRecent
);

export const selectCountsMostRecentBasicState = createSelector(
  selectCountsState,
  (state) => state.mostRecent
);

export const selectCountsCurrentTypeState = createSelector(
  selectCountsState,
  (state) => ({
    currentType: state.currentType,
    currentId: state.currentId
  })
);

export const selectCountsCountedTotalState = createSelector(
  selectCountsState,
  (state) => state.totalCounted
);

export const selectCountsSortTypeState = createSelector(
  selectCountsState,
  (state) => state.sortType
);

export const selectCurrentPage = createSelector(
  selectCountsState,
  (state: fromCounts.State) => state.currentPage
);